import ErrorBoundary from "@/hoc/ErrorBoundary/ErrorBoundary.jsx";
import { lazy } from "react";

const PropertyListing = lazy(() => import("./listing/index.jsx"));
const SignatureListing = lazy(() => import("./listing/signatureListing.jsx"));
const PropertyDetail = lazy(() => import("./detail/index.jsx"));
const PropertyManagement = lazy(() => import("./management/index.jsx"));
const FavouritesProperties = lazy(() =>
  import("./favouritesProperties/index.jsx")
);
const CompareProperties = lazy(() => import("./compareProperty/index.jsx"));
const AddPropertyPage = lazy(() =>
  import("./addProperty/addPropertySteper.jsx")
);

export const propertyRoutes = {
  children: [
    {
      path: "/property-listing",
      element: <PropertyListing />,
      errorElement: <ErrorBoundary />
    },
    {
      path: "/signature-property-listing",
      element: <SignatureListing />,
      errorElement: <ErrorBoundary />
    },
    {
      path: "/property-detail/:id",
      element: <PropertyDetail />,
      errorElement: <ErrorBoundary />
    }
  ]
};

export const propertyRoutesPrivate = {
  children: [
    {
      path: "add-property",
      element: <AddPropertyPage />,
      errorElement: <ErrorBoundary />,
      title: "header.addProperty"
    },
    {
      path: "edit-property/:propertyId",
      element: <AddPropertyPage />,
      errorElement: <ErrorBoundary />,
      title: "addProperty.editTitle"
    },
    {
      path: "my-properties",
      element: <PropertyManagement />,
      errorElement: <ErrorBoundary />,
      title: "common.myProperties"
    },
    {
      path: "favorite",
      element: <FavouritesProperties />,
      errorElement: <ErrorBoundary />,
      title: "common.favorite"
    },
    {
      path: "compare-properties",
      element: <CompareProperties />,
      errorElement: <ErrorBoundary />,
      title: "compareProperties.title"
    }
  ]
};
